<template>
  <div class="tender-query-questions">
    <div
      v-for="(item, index) in questions"
      :key="item.id"
    >
      <div class="row question-order">
        <div class="small-11 medium-11 large-11 columns"><label :class="{ 'required-flag': !(readonly || isBidder) }">{{ $t('tender.query.question') }} {{ item.order }}</label></div>
        <a
          class="columns delete-btn"
          @click="$emit('deleteQuestion', index)"
          v-show="allowDelete"
        >
          <i
            class="icon-delete"
            aria-hidden="true"
          />
        </a>
      </div>
      <div
        v-if="!(isBidder || readonly)"
        class="question-edit-mode"
      >
        <TextField
          class="question"
          :value="item.question"
          :placeholder="$t('tender.query.placeholder.question')"
          @updateValue="val => $emit('updateQuestion', index, 'question', val)"
          :parentNode="FORM_SRC_TENDER_QUERY"
          required
        />
      </div>

      <div
        v-else
        class="question-view-mode"
      >
        <div class="question">
          <TextField
            :readonly="true"
            :value="item.question"
          />
        </div>
        <div
          class="answer"
          v-if="showAnswer"
        >
          <div><label :class="{ 'required-flag': contractorEditMode }">{{ $t('tender.query.answer', [vendorName] ) }}:</label></div>
          <div
            class="row readonly"
            v-if="readonly"
          >
            <TextField
              :readonly="true"
              :value="getAnswer(item.answer)"
            />
          </div>
          <TextField
            v-if="contractorEditMode"
            :value="item.answer"
            :placeholder="$t('tender.query.placeholder.answer')"
            @updateValue="val => $emit('updateQuestion', index, 'answer', val)"
            :parentNode="FORM_SRC_TENDER_QUERY"
            required
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/controls/TextField'

import { mapGetters } from 'vuex'
import { queryStatus, queryStatusMap } from '@/utils/locale'
import { FORM_SRC_TENDER_QUERY } from '@/utils/consts'

export default {
  name: 'question',
  components: {
    TextField,
  },
  props: {
    query: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      FORM_SRC_TENDER_QUERY,
    }
  },

  methods: {
    getAnswer (answer) {
      if (queryStatus.NO_RESPONSE === this.query.status) {
        return queryStatusMap.NO_RESPONSE
      }
      if (queryStatus.SUBMITTED === this.query.status) {
        return answer
      }
      return ''
    },
  },

  computed: {
    ...mapGetters('user', ['isContractor']),
    ...mapGetters('tenders', ['currentBid', 'isRepresentative']),
    isBidder () {
      return this.isContractor && !this.isRepresentative
    },
    allowDelete () {
      return !this.isBidder && this.questions.length > 1 && this.query.status === queryStatus.DRAFT && !this.readonly
    },
    contractorEditMode () {
      return this.isBidder && !this.readonly
    },
    questions () {
      return this.query.questions || []
    },
    vendorName () {
      return deep(this.currentBid, 'company.name')
    },
    showAnswer () {
      return this.isBidder ||
        (this.query.status && ![queryStatus.DRAFT, queryStatus.ISSUED].includes(this.query.status))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/query';
.tender-query-questions {
  padding-top: 20px;
}
.readonly {
  padding-left: 20px;
}
</style>

<style lang="scss">
.question-edit-mode, .answer {
  .text-field {
    border: solid 1px #EBEBEB;
    margin: 0 0 6px 0;

    .text-input {
      width: 99%;
      textarea {
        min-height: 105px;
        padding: 12px 0;
        margin: 0;
        border: none;
        border-radius: 0;
        width: 100%;
        box-shadow: none;
      }
    }
  }
}

.question-edit-mode .text-field {
  margin: 0 0 6px 0!important;
}

.question-view-mode {
  .question .text-field, .answer .readonly .text-field {
    width: calc(100% - 55px);
    margin: 0;
    padding: 14px 0;
    border: none;

    pre {
      overflow: hidden;
    }
    p {
      margin-bottom: 0;
    }
  }

  .answer .text-field {
    border: none;

    .text-input {
      textarea {
        padding: 14px 0 14px 20px;
      }
    }
  }
}
</style>
